<template>
  <div class="flex flex-col min-h-screen">
    <Header v-if="showLayout" />

    <main class="flex-grow">
      <router-view />
    </main>

    <Footer v-if="showLayout" />

    <CookieBanner v-if="showBanner" @accepted="onAccept" @rejected="onReject" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import CookieBanner from './components/CookieBanner.vue';
import Header from '@/components/SiteHeader.vue';
import Footer from '@/components/SiteFooter.vue';

const showBanner = ref(false);

const hiddenLayoutRoutes = ['Login', 'Register', 'PublicPageView', 'Preview', 'Admin', 'AdminLogin'];
const route = useRoute();
const router = useRouter();

const showLayout = computed(() => {
  if (hiddenLayoutRoutes.includes(route.name)) return false;
  if (route.path.startsWith('/dashboard')) return false;
  return true;
});

function loadGTM() {
  if (window.gtmLoaded) return; // éviter doublon
  window.gtmLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  // Injecter script GTM dans <head>
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtm.js?id=GTM-KPQG4MQZ";
  script.onload = () => {
    // GTM prêt → envoyer consentement si besoin
    window.dataLayer.push({ event: "cookies_accepted" });
    // Envoyer un premier page_view
    window.dataLayer.push({
      event: "page_view",
      page_path: route.fullPath,
      page_title: document.title,
    });
  };
  document.head.appendChild(script);

  // Injecter le <noscript><iframe> juste après <body>
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KPQG4MQZ"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noscript, document.body.firstChild);
}

function onAccept() {
  localStorage.setItem("cookies-choice", "accepted");
  showBanner.value = false;
  loadGTM();
}

function onReject() {
  localStorage.setItem("cookies-choice", "rejected");
  showBanner.value = false;
}

onMounted(() => {
  const choice = localStorage.getItem("cookies-choice");
  if (!choice) {
    showBanner.value = true;
  } else if (choice === "accepted") {
    loadGTM();
  }
});

// Écouter les changements de route → envoyer un page_view
router.afterEach((to) => {
  if (localStorage.getItem("cookies-choice") === "accepted" && window.dataLayer) {
    window.dataLayer.push({
      event: "page_view",
      page_path: to.fullPath,
      page_title: document.title,
    });
  }
});
</script>
